// Root-domain `tm_lang` cookie written by MyAccount, SSO, Activation and MyDashboard
// so GTM reads one consistent page language. The app itself never reads it.

const COOKIE_NAME = 'tm_lang';
const ONE_YEAR_SECONDS = 60 * 60 * 24 * 365;

/**
 * Normalize a locale such as "JA_JP" or "ZH-TW" to BCP 47 ("ja-JP", "zh-TW").
 */
export const toBcp47 = (locale) => {
  if (!locale) return '';
  const [lang, region] = locale.replace('_', '-').split('-');
  return region ? `${lang.toLowerCase()}-${region.toUpperCase()}` : lang.toLowerCase();
};

/**
 * Services live under different root domains (trendmicro.com / trendlife.com) and
 * browsers drop a cookie whose Domain does not cover the current host, so pick the
 * configured root domain the host belongs to. Unknown hosts (e.g. localhost) get a
 * host-only cookie.
 */
export const resolveCookieDomain = (hostname, allowedDomains) =>
  (allowedDomains || '')
    .split(',')
    .map((d) => d.trim())
    .filter(Boolean)
    .find((d) => {
      const root = d.replace(/^\./, '');
      return hostname === root || hostname.endsWith(`.${root}`);
    });

export const buildTmLangCookie = (locale, domain) =>
  `${COOKIE_NAME}=${toBcp47(locale)}; Path=/; Max-Age=${ONE_YEAR_SECONDS}; Secure; SameSite=Lax` +
  (domain ? `; Domain=${domain}` : '');

export const setTmLangCookie = (locale) => {
  if (!toBcp47(locale)) return;
  const domain = resolveCookieDomain(window.location.hostname, process.env.TM_LANG_COOKIE_DOMAINS);
  document.cookie = buildTmLangCookie(locale, domain);
};
